var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 74.5 48.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.7,22l2.3,1.9,3.7,3.2c1.7,1.4,4.4,1.4,6.1,0l2.9-2.5,2.3-1.9L71.5.4c-.5,0-1-.3-1.5-.3H4.7c-.5-.1-1-.1-1.4,0,0,0,25.4,21.8,25.4,21.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.5,4.7c0-1-.3-1.9-.8-2.6l-25.7,22.4,25.6,21.9c.5-.8.8-1.7.8-2.6V4.7h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.7,26.4l-5.1,4.5c-1.7,1.5-4.4,1.5-6.1,0l-5.9-5L3.1,48.1c.5.2,1,.3,1.5.3h65.1c.5,0,1,0,1.4-.2,0,0-25.4-21.8-25.4-21.8Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M.8,2c-.5.7-.8,1.7-.8,2.7v39c0,1,.3,1.9.8,2.6l25.7-22.4L.8,2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/icon-email.2cbdbd834985a313c8a6021a5168e458.svg";
export { ForwardRef as ReactComponent };